export const ROUTE_PATH_HOME = "/home";
export const ROUTE_PATH_WIKI_MANAGEMENT = "/wiki-management";
export const ROUTE_PATH_MARKDOWN_EDITOR = "/markdown-editor";
export const ROUTE_PATH_ASSETS_UPLOAD = "/assets-upload";
